import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import { getEvents, getLocations } from "helpers/fakebackend_helper";
import AddEventModal from "./AddEventModal";
import ImportEventsModal from "./ImportEventsModal";
import EventsTable from "./EventsTable";

const Events = props => {
  document.title = "Events | CurbDash";
  const user = JSON.parse(localStorage.getItem("authUser"));
  const [locations, setLocations] = useState([])
  const [events, setEvents] = useState([])
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const loadEvents = async () => {
    const { data } = await getEvents(user.token);
    setEvents(data);
  }

  const loadLocations = async () => {
    const { data } = await getLocations(user.token);
    setLocations(data);
  }

  useEffect(() => {
    loadLocations()
    loadEvents()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content" style={{ marginTop: -70, backgroundColor: "rgb(38, 37, 35)" }}>
        <Container fluid>
          <Row className="d-flex justify-content-between align-items-center mb-4">
            <Col sm="auto">
              <Button
                className="button-gradient-bg"
                onClick={() => setIsAddModalOpen(!isAddModalOpen)}
              >
                Add Event
              </Button>
            </Col>
            <Col sm="auto">
              <ImportEventsModal />
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <EventsTable events={events} locations={locations} loadEvents={loadEvents} />
            </Col>
          </Row>
        </Container>
      </div>
      <AddEventModal
        isOpen={isAddModalOpen}
        toggle={() => setIsAddModalOpen(!isAddModalOpen)}
        handleSave={() => {
          loadEvents()
          setIsAddModalOpen(false)
        }}
        locations={locations}
      />
    </React.Fragment>
  );
};

Events.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Events);
